'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article5() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задачи
					</Typography>
					<Typography variant='p1'>
						Минимизировать издержки производства с помощью инструментов цифровизации. Обеспечить масштабируемую
						модель системы по увеличению производительности производства и эффективности труда.
					</Typography>
					<Typography variant='p1'>
						В сотрудничестве с ИЗГТ нами должна была быть разработана дорожная карта по внедрению цифровых
						изменений, от концепции реализации. Цель партнерства состоит в том, чтобы создать эффективное,
						результативное и непрерывное ускорение и улучшение производственных процессов.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Выполненные работы:
					</Typography>
					<Typography variant='p1'>
						Произведен технологический аудит текущей системы учета инструмента на предприятии. Выявлены основные
						проблемы и определены точки роста.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/5-1.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Для исключения издержек определены зоны контроля входа и выхода сотрудников.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/5-2.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Разработан проект установки и настройки аппаратных комплексов и систем с машинным зрением. Исключен
						вынос инструмента с производства.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/5-3.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>Внедрены RFID-метки с антивандальной системой нанесения.</Typography>
					<Typography variant='p1'>
						На основании проекта доработано программное обеспечение системы учета инструмента.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/5-4.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Внедрена система штрихкодирования и интегрирована в систему складского учета
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/5-5.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Результат:
					</Typography>
					<Typography variant='p1'>
						Работая вместе с командой true.code в области проектирования и управления новых систем, ИЗГТ
						представили своим сотрудникам новый способ работы. Обширный опыт true.code в цифровой трансформации
						производств позволил внедрить новые эффективные процессы в работу предприятия.
					</Typography>
					<Typography variant='p1'>
						Внедрив новую модель работы, наш клиент стал более гибким и эффективным. Масштабирование компании
						клиента никак не мешает масштабированию внедренных нами систем.
					</Typography>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
